import { render, staticRenderFns } from "./AllQnAList.vue?vue&type=template&id=2d0b3ce6"
import script from "./AllQnAList.vue?vue&type=script&lang=js"
export * from "./AllQnAList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports